import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { BiigApp } from './components/BiigApp';
import { ArchitectureDiagram } from './components/ArchitectureDiagram';
import { ProjectStructure } from './components/ProjectStructure';
import WhatsAppDashboard from './components/WhatsAppDashboard';
import WhatsAppTestDashboard from './components/WhatsAppTestDashboard';
import { FacebookTest } from './components/FacebookTest';
import { UnifiedChat } from './components/UnifiedChat';
import { AITrainer } from './components/AITrainer';
import { InstagramTestDashboard } from './components/InstagramTestDashboard';
import { InstagramTemplateBuilder } from './components/InstagramTemplateBuilder';
import { IntegrationChecklistV2 } from './components/IntegrationChecklistV2';
import { InstagramPostResponder } from './components/InstagramPostResponder';
import { DevTodos } from './components/DevTodos';
import { CrudDashboard } from './components/CrudDashboard';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<BiigApp />} />
        <Route path="/setup" element={<IntegrationChecklistV2 />} />
        <Route path="/whatsapp" element={<WhatsAppDashboard />} />
        <Route path="/whatsapp-test" element={<WhatsAppTestDashboard />} />
        <Route path="/instagram-test" element={<InstagramTestDashboard />} />
        <Route path="/instagram-templates" element={<InstagramTemplateBuilder />} />
        <Route path="/instagram-responder" element={<InstagramPostResponder />} />
        <Route path="/facebook-test" element={<FacebookTest />} />
        <Route path="/chat" element={<UnifiedChat />} />
        <Route path="/ai-trainer" element={<AITrainer />} />
        <Route path="/architecture" element={<ArchitectureDiagram />} />
        <Route path="/structure" element={<ProjectStructure />} />
        <Route path="/crud" element={<CrudDashboard />} />
      </Routes>
      <DevTodos />
    </>
  );
}

export default App;
